import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  moonPhaseLabel: {
    marginLeft: Theme.px(30),
    marginRight: Theme.px(18),
    paddingTop: Theme.px(4),
  },
  moonPhaseValue: {
    marginLeft: Theme.px(18),
  },
});
